import { Article, ScreenContainer, Button, HeroSection, Hero, HeroBody, HeroTitle, HeroTeaser, HeroActionList, HeroAction, FeatureSection, FeatureList, Feature, FeatureTitle, FeatureText, FeatureImage, SiblingNav, SiblingNavLink } from "smooth-doc/components";
import heroBackgroundImageURL from "../../../../images/hero-background.png";
import icon1mageURL from "../../../../images/icon1.png";
import icon2mageURL from "../../../../images/icon2.png";
import icon3mageURL from "../../../../images/icon3.png";
import icon4mageURL from "../../../../images/icon4.png";
import icon5mageURL from "../../../../images/icon5.png";
import icon6mageURL from "../../../../images/icon6.png";
import icon7mageURL from "../../../../images/icon7.png";
import icon8mageURL from "../../../../images/icon8.png";
import * as React from 'react';
export default {
  Article,
  ScreenContainer,
  Button,
  HeroSection,
  Hero,
  HeroBody,
  HeroTitle,
  HeroTeaser,
  HeroActionList,
  HeroAction,
  FeatureSection,
  FeatureList,
  Feature,
  FeatureTitle,
  FeatureText,
  FeatureImage,
  SiblingNav,
  SiblingNavLink,
  heroBackgroundImageURL,
  icon1mageURL,
  icon2mageURL,
  icon3mageURL,
  icon4mageURL,
  icon5mageURL,
  icon6mageURL,
  icon7mageURL,
  icon8mageURL,
  React
};